<template>
    <div class="page" :class="{ 'page__has-bar': form.main.status === 0 }">
        <div class="page__bd">
            <div class="form-preview weui-form-preview">
                <div class="weui-form-preview__bd">
                    <div class="weui-form-preview__item">
                        <label class="weui-form-preview__label">任务</label>
                        <span class="weui-form-preview__value weui-form-preview__value-icon">{{ form.main.title }}
                        </span>
                    </div>
                    <div class="weui-form-preview__item">
                        <label class="weui-form-preview__label">说明</label>
                        <span class="weui-form-preview__value">{{
                            form.main.content
                        }}</span>
                    </div>
                    <div class="weui-form-preview__item">
                        <label class="weui-form-preview__label">发起人</label>
                        <span class="weui-form-preview__value">{{ form.main.creatorName }}</span>
                    </div>
                    <div class="weui-form-preview__item">
                        <label class="weui-form-preview__label">发起时间</label>
                        <span class="weui-form-preview__value">{{ form.main.createTime }}</span>
                    </div>
                    <div class="weui-form-preview__item">
                        <label class="weui-form-preview__label">指定执行人</label>
                        <span class="weui-form-preview__value">{{ form.main.assignee }}</span>
                    </div>
                    <div class="weui-form-preview__item" v-if="form.main.status === 1">
                        <label class="weui-form-preview__label">完成人</label>
                        <span class="weui-form-preview__value">{{ form.main.executorName }}</span>
                    </div>
                    <div class="weui-form-preview__item" v-if="form.main.status === 1">
                        <label class="weui-form-preview__label">完成时间</label>
                        <span class="weui-form-preview__value"> {{ form.main.executeTime }}</span>
                    </div>
                </div>
            </div>

            <collapse class="form-preview weui-form-preview" :title="'任务明细（' + form.items.length + '条）'"
                v-if="form.items && form.items.length">
                <div class="weui-form-preview__bd form-detail-preview" v-for="(item, index) in form.items"
                    :key="item.id">
                    <div class="form-detail-preview_num">{{ index + 1 }}</div>
                    <div>
                        <div class="weui-form-preview__item">
                            <label class="weui-form-preview__label">单据</label>
                            <span class="weui-form-preview__value">{{ item.bizCode }}</span>
                        </div>
                        <div class="weui-form-preview__item" v-if="item.status === 1">
                            <label class="weui-form-preview__label">完成人</label>
                            <span class="weui-form-preview__value">{{ item.executorName }}</span>
                        </div>
                        <div class="weui-form-preview__item" v-if="item.status === 1">
                            <label class="weui-form-preview__label">完成时间</label>
                            <span class="weui-form-preview__value"> {{ item.executeTime }}</span>
                        </div>
                    </div>
                </div>
            </collapse>
        </div>

        <div class="footer-bar weui-dialog__ft" v-if="form.main.status === 0">
            <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="complete">完成</a>
        </div>
    </div>
</template>

<script>
import form from "@/mixins/form.js";
import Collapse from "@/components/Collapse.vue";

export default {
    mixins: [form],
    components: {
        Collapse
    },
    data() {
        return {
            baseUrl: "/api/oa/worktask"
        };
    },
    methods: {
        complete() {
            var me = this, id = me.form.main.id;
            me.$loading({
                method: 'post',
                url: `${me.baseUrl}/complete/${id}?next=true`
            }).then(res => {
                if (res.success) {
                    if (!res.data || !res.data.next) {
                        me.$weui.toast("操作成功", 2000);
                    } else {
                        me.$weui.toast("操作成功，即将进入下一条", 1000);
                        setTimeout(() => {
                            me.$router.replace({
                                name: 'WorkTask',
                                params: {
                                    id: res.data.next
                                }
                            });
                        }, 1000);
                    }
                } else if (res.data && res.data.list) {
                    me.$weui.topTips(res.data.list[0].message, 3000);
                } else {
                    me.$weui.topTips(res.message, 3000);
                }
            });
        }
    }
};
</script>